module.exports = __webpack_public_path__ + "static/media/20_CORTININHA_SEM_BOJO_ESTAMPADO_01.c70b544e.jpg";